<template>
	<div class="pagination">
		<div class="pagination-first pagination-element pagination-arrow" v-if="page > 1" @click="firstPage()" content="Primera página" v-tippy="{ placement: 'left', arrow: true }" :class="loading ? 'arrow-loading' : ''"><i class="bx bx-first-page"></i></div>
		<div class="pagination-previous pagination-element pagination-arrow" v-if="page > 1" @click="prevPage()" content="Página anterior" v-tippy="{ placement: 'left', arrow: true }" :class="loading ? 'arrow-loading' : ''"><i class="bx bx-left-arrow-alt"></i></div>
		<span class="pagination-element" v-if="maxPaginas !== 0">Página {{ page }} de {{ maxPaginas }}</span>
		<span class="pagination-element pagination-element-no-results" v-else>Sin resultados</span>
		<div class="pagination-next pagination-element pagination-arrow" v-if="page < maxPaginas" @click="nextPage()" content="Página siguiente" v-tippy="{ placement: 'left', arrow: true }" :class="loading ? 'arrow-loading' : ''"><i class="bx bx-right-arrow-alt"></i></div>
		<div class="pagination-last pagination-element pagination-arrow" v-if="page < maxPaginas" @click="lastPage()" content="Última página" v-tippy="{ placement: 'left', arrow: true }" :class="loading ? 'arrow-loading' : ''"><i class="bx bx-last-page"></i></div>
	</div>
</template>

<script>
export default {
	props: {
		page: Number,
		maxPaginas: Number,
		loading: Boolean,
	},
	methods: {
		prevPage() {
			if (!this.loading) {
				this.$emit("prevPage");
			}
		},
		nextPage() {
			if (!this.loading) {
				this.$emit("nextPage");
			}
		},
		firstPage() {
			if (!this.loading) {
				this.$emit("firstPage");
			}
		},
		lastPage() {
			if (!this.loading) {
				this.$emit("lastPage");
			}
		},
	},
};
</script>

<style lang="scss" scoped>
	.pagination {
		width: 100%;
		margin-top: 20px;
		@include flex(row, flex-end, center);

		.pagination-element {
			margin-left: 10px;

			&.pagination-element-no-results{
				color: #222;
				font-weight: 400;
			}
		}

		.pagination-arrow {
			cursor: pointer;
			padding: 4px;
			background-color: #f2f4f8;
			border-radius: 5px;
			@include flex(row, center, center);
			transition: all 0.2s;

			&:hover {
				opacity: 0.9;
			}

			i {
				font-size: 18px;
				color: #222;
			}

			&.arrow-loading {
				cursor: not-allowed;
				opacity: 0.4;
			}
		}

		span {
			font-size: 13px;
			font-weight: 500;
		}
	}
</style>